import { create } from "zustand";
import { querystring } from "zustand-querystring";
import {
  FulfillmentFilterType,
  OrderContainsType,
  OrderListSortType,
  PaymentStatusType,
  PaymentTypeType,
} from "./AllOrdersListFilterTypes";
import { OrderStatusesEnumType } from "@sellar-io/api-v2/types";

export type AllOrdersListStoreState = {
  deliveryStatus: FulfillmentFilterType;
  orderContains: OrderContainsType;
  orderStatuses: OrderStatusesEnumType[];
  paymentStatus: PaymentStatusType;
  paymentType: PaymentTypeType;
  search: string;
  sort: OrderListSortType;
};

type AllOrdersListStoreActions = {
  setState: (state: AllOrdersListStoreState) => void;

  setDeliveryStatus: (deliveryStatus: FulfillmentFilterType) => void;
  setOrderContains: (orderContains: OrderContainsType) => void;
  setOrderStatuses: (orderStatuses: OrderStatusesEnumType[]) => void;
  setPaymentStatus: (paymentStatus: PaymentStatusType) => void;
  setPaymentType: (paymentType: PaymentTypeType) => void;
  setSearch: (search: string) => void;
  setSort: (sort: OrderListSortType) => void;

  reset: () => void;
};

const initialAllOrdersListStoreState: AllOrdersListStoreState = {
  deliveryStatus: "",
  orderContains: "",
  orderStatuses: [],
  paymentStatus: "",
  paymentType: "",
  search: "",
  sort: "created_at_desc",
};

type AllOrdersListStoreType = AllOrdersListStoreState &
  AllOrdersListStoreActions;

export const useAllOrdersListStore = create<AllOrdersListStoreType>()(
  querystring<AllOrdersListStoreType>(
    (set) => ({
      ...initialAllOrdersListStoreState,
      setState: (newState: AllOrdersListStoreState) => set(newState),

      setDeliveryStatus: (deliveryStatus: FulfillmentFilterType) =>
        set({ deliveryStatus }),
      setOrderContains: (orderContains: OrderContainsType) =>
        set({ orderContains }),
      setOrderStatuses: (orderStatuses: OrderStatusesEnumType[]) =>
        set({ orderStatuses }),
      setPaymentStatus: (paymentStatus: PaymentStatusType) =>
        set({ paymentStatus }),
      setPaymentType: (paymentType: PaymentTypeType) => set({ paymentType }),
      setSearch: (search: string) => set({ search }),
      setSort: (sort: OrderListSortType) => set({ sort }),

      reset: () => set(initialAllOrdersListStoreState),
    }),
    {
      select(pathname) {
        const persistParam = pathname.includes("/orders");
        return {
          deliveryStatus: persistParam,
          orderContains: persistParam,
          orderStatuses: persistParam,
          paymentStatus: persistParam,
          paymentType: persistParam,
          search: persistParam,
          sort: persistParam,
        };
      },
    },
  ),
);
